import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL_NEW } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params';

export type LanguageAndConfigs = {
  result: LanguageConfiguration[];
  count: number;
  total_results: number;
};

export interface LanguageConfiguration {
  bcp47: string;
  id: number;
  is_enabled: boolean;
  is_private: boolean;
  key: string;
  name: string;
  type: number; // 1 = Base, other = Custom
}

export const useLanguageAndConfig = () => {
  const { searchParams } = useNewAppSearchParams();
  const [sp] = useSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sort = (searchParams.sort as string | undefined) || undefined;
  const direction =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;

  const allQ = sp.getAll('q').filter(Boolean);

  const fetchLanguageAndConfig = async () => {
    const { languageAndConfigs } = GET_URL_NEW({
      offset,
      limit,
      sort,
      direction,
      q: allQ.length > 0 ? allQ : undefined
    });

    const { data } = await Axios.get<LanguageAndConfigs>(
      languageAndConfigs as string
    );
    return data;
  };

  return useQuery<LanguageAndConfigs, AxiosError<BaseError>>(
    ['languageAndConfigs', offset, limit, allQ.join(','), sort, direction],
    fetchLanguageAndConfig,
    {
      useErrorBoundary: false,
      keepPreviousData: true,
      staleTime: 5 * 60 * 1000
    }
  );
};
